export const ETA_MODEL ={
    estimatedTimeOfArrivalDate: null,
    userId: null, 
    vehicleId: null,
}